var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.8 0H3.2C1.44 0 0.016 1.2375 0.016 2.75L0 19.25C0 20.7625 1.44 22 3.2 22H28.8C30.56 22 32 20.7625 32 19.25V2.75C32 1.2375 30.56 0 28.8 0ZM28.16 5.84375L16.848 11.9213C16.336 12.1963 15.664 12.1963 15.152 11.9213L3.84 5.84375C3.44 5.62375 3.2 5.2525 3.2 4.85375C3.2 3.9325 4.368 3.3825 5.28 3.86375L16 9.625L26.72 3.86375C27.632 3.3825 28.8 3.9325 28.8 4.85375C28.8 5.2525 28.56 5.62375 28.16 5.84375Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"16","y1":"0","x2":"16","y2":"22","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.239583","stopColor":"#11D4FF","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#058D27","key":1})]))]);
}

Mail.defaultProps = {"width":"32","height":"22","viewBox":"0 0 32 22","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
